
import { defineComponent, PropType, ref } from 'vue'

export default defineComponent({
  name: 'Submenu',
  props: {
    items: {
      type: Array as PropType<Array<unknown>>,
      default: []
    },
    root: {
      type: Boolean,
      default: false
    }
  },
  emits: ['item-click'],
  setup(_, { emit }) {
    const activeIndex = ref<number>()
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onItemClick = (event: Event, item: any, index: number) => {
      if (item.disabled) {
        event.preventDefault()
        return
      }

      if (!item.to && !item.url) {
        event.preventDefault()
      }

      //execute command
      if (item.command) {
        item.command({ originalEvent: event, item: item })
      }

      activeIndex.value = index === activeIndex.value ? undefined : index

      emit('item-click', {
        originalEvent: event,
        item: item
      })
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const visible = (item: any) => {
      return typeof item.visible === 'function'
        ? item.visible()
        : item.visible !== false
    }
    return { activeIndex, onItemClick, visible }
  }
})
